import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { MapContainer, TileLayer, Marker, Popup, Polyline, useMap } from 'react-leaflet';
import L from 'leaflet';
import { apiGet, apiPostJSON } from '../services/api';
import './BcpMap.css'; 

delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
  iconUrl:       require('leaflet/dist/images/marker-icon.png'),
  shadowUrl:     require('leaflet/dist/images/marker-shadow.png'),
});

const redIcon = new L.Icon({
  iconUrl: 'https://raw.githubusercontent.com/pointhi/leaflet-color-markers/master/img/marker-icon-2x-red.png',
  shadowUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-shadow.png',
  iconSize: [25, 41],
  iconAnchor: [12, 41],
  popupAnchor: [1, -34],
  shadowSize: [41, 41]
});

const ChangeMapCenter = ({ center }) => {
  const map = useMap();
  map.setView(center, map.getZoom());
  return null;
};

const BcpSearch = () => {
  const navigate = useNavigate();
  const [addressInput, setAddressInput] = useState("");
  const [radiusInput, setRadiusInput] = useState("5.0");
  const [searching, setSearching] = useState(false);
  const [searchResults, setSearchResults] = useState(null);
  const [errorMsg, setErrorMsg] = useState("");
  const [mapCenter, setMapCenter] = useState([34.6937, 135.5023]);

  const handleSearchSubmit = async (e) => {
    e.preventDefault();
    if (!addressInput.trim()) {
        setErrorMsg("住所を入力してください。");
        return;
    }

    setSearching(true);
    setErrorMsg("");
    setSearchResults(null);

    try {
        const encodedAddress = encodeURIComponent(addressInput.trim());
        const encodedRadius = encodeURIComponent(radiusInput);

    
        const res = await apiGet(`/api/shelters/by-address/?address=${encodedAddress}&radius_km=${encodedRadius}`);
        
        console.log("API Response:", res); 
        
        const latitude = res?.data?.lat || res?.lat;
        const longitude = res?.data?.lng || res?.lng;

        if (latitude && longitude) {
            setMapCenter([parseFloat(latitude), parseFloat(longitude)]);
        }
      
        const sheltersData = res?.data?.shelters || res?.shelters || [];
        
        setSearchResults(sheltersData);

    } catch (err) {
        console.error(err);
        const msg = err.response?.data?.detail || err.message || "避難所の検索に失敗しました。";
        setErrorMsg(msg);
    } finally {
        setSearching(false);
    }
  };

  return (
    <div className="bcp-page bcp-search-page" style={{ padding: "20px", maxWidth: "600px", margin: "0 auto", fontFamily: "Meiryo, sans-serif" }}>
      <header className="bcp-menu-header" style={{ marginBottom: "20px" }}>
        <h2 className="bcp-menu-title" >🔍 任意住所から避難所検索</h2>
        <p className="bcp-menu-desc" >調べたい場所の住所と 半径 を 登録して、最寄りの避難所を検索できます。</p>
      </header>

    
      <div className="bcp-address-search-form" style={{ background: "#f8fafc", padding: "20px", borderRadius: "8px", border: "1px solid #e2e8f0", boxShadow: "0 2px 4px rgba(0,0,0,0.02)" }}>
        <form onSubmit={handleSearchSubmit} style={{ display: "flex", flexDirection: "column", gap: "15px" }}>
          
          <div style={{ display: "flex", flexDirection: "column", gap: "6px" }}>
            <label style={{ fontWeight: "bold", fontSize: "0.9rem", color: "#334155" }}>住所を入力してください:</label>
            <input 
              type="text"
              placeholder="例: 大阪市中央区大手前..."
              value={addressInput}
              onChange={(e) => setAddressInput(e.target.value)}
              style={{ padding: "10px", borderRadius: "6px", border: "1px solid #cbd5e1", fontSize: "14px", width: "100%", boxSizing: "border-box" }}
            />
          </div>

          <div style={{ display: "flex", alignItems: "center", gap: "10px", flexWrap: "wrap" }}>
            <div style={{ display: "flex", alignItems: "center", gap: "6px" }}>
              <label style={{ fontSize: "0.9rem", fontWeight: "bold", color: "#475569" }}>検索半径:</label>
              <select 
                value={radiusInput} 
                onChange={(e) => setRadiusInput(e.target.value)}
                style={{ padding: "8px", borderRadius: "6px", border: "1px solid #cbd5e1", background: "white", fontSize: "14px" }}
              >
                <option value="1.0">1 km 以内</option>
                <option value="3.0">3 km 以内</option>
                <option value="5.0">5 km 以内 (既定)</option>
                <option value="10.0">10 km 以内</option>
              </select>
            </div>

            <button 
              type="submit" 
              disabled={searching}
              style={{ marginLeft: "auto", padding: "10px 24px", background: "#16a34a", color: "white", border: "none", borderRadius: "6px", fontWeight: "bold", fontSize: "14px", cursor: searching ? "not-allowed" : "pointer" }}
            >
              {searching ? "検索中..." : "🔍 検索"}
            </button>
          </div>
        </form>

        {errorMsg && <p style={{ color: "#dc2626", fontSize: "0.85rem", marginTop: "10px", fontWeight: "bold" }}>{errorMsg}</p>}
      </div>

     
      {searchResults && (
        <div className="bcp-search-results" style={{ marginTop: "25px" }}>
          <h4 style={{ fontSize: "1rem", color: "#1e293b", marginBottom: "12px", borderBottom: "2px solid #cbd5e1", paddingBottom: "6px", fontWeight: "bold" }}>
            📍 検索結果 ({searchResults.length} 件)
          </h4>
          {/*}
          {searchResults.length === 0 ? (
            <div style={{ textAlign: "center", padding: "20px", color: "#64748b", background: "#f8fafc", borderRadius: "6px", border: "1px dashed #cbd5e1", fontSize: "0.9rem" }}>
              指定された半径内に避難所が見つかりませんでした。検索半径を広げて再度お試しください。
            </div>
          ) : (
            <div style={{ display: "flex", flexDirection: "column", gap: "10px", maxHeight: "400px", overflowY: "auto", paddingRight: "4px" }}>
              {searchResults.map((sh) => (
                <div key={sh.id} style={{ background: "#ffffff", padding: "12px 15px", borderRadius: "8px", border: "1px solid #e2e8f0", boxShadow: "0 1px 3px rgba(0,0,0,0.02)", display: "flex", justifyContent: "space-between", alignItems: "center", gap: "10px" }}>
                  <div style={{ minWidth: 0 }}>
                    <div style={{ fontWeight: "bold", color: "#1e293b", fontSize: "0.95rem", marginBottom: "4px", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>{sh.name}</div>
                    <div style={{ color: "#64748b", fontSize: "0.8rem", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>{sh.address}</div>
                  </div>
                  <div style={{ flexShrink: 0, textAlign: "right", background: "#fff7ed", padding: "4px 8px", borderRadius: "4px", border: "1px solid #ffedd5" }}>
                    <span style={{ color: "#ea580c", fontWeight: "bold", fontSize: "0.85rem" }}>
                      {sh.distance_km} km
                    </span>
                  </div>
                </div>
              ))}
            </div>
          )}
            */}
            {searchResults && (
                <div style={{ height: "300px", width: "100%", marginTop: "20px", borderRadius: "8px", overflow: "hidden", border: "1px solid #cbd5e1" }}>
                    <MapContainer center={mapCenter} zoom={14} style={{ height: "100%", width: "100%" }}>
                    <TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />
                    <ChangeMapCenter center={mapCenter} />
                    
                    {/*}
                    <Marker position={mapCenter}>
                        <Popup>🔍 検索の中心位置</Popup>
                    </Marker>
                    */}
                    <Marker position={mapCenter} icon={redIcon}>
                        <Popup>
                        <div style={{ textAlign: "center" }}>
                            <strong style={{ color: "#dc2626" }}>🏠 入力された住所 (検索中心)</strong>
                            <p style={{ margin: "4px 0 0 0", fontSize: "12px" }}>{addressInput}</p>
                        </div>
                        </Popup>
                    </Marker>
                  
                    {searchResults.map((sh) => (
                        <Marker key={sh.id} position={[parseFloat(sh.latitude), parseFloat(sh.longitude)]}>
                        <Popup>
                            <strong>{sh.name}</strong><br />
                            {sh.address}<br />
                            📏 距離: {sh.distance_km} km
                        </Popup>
                        </Marker>
                    ))}
                    </MapContainer>
                </div>
                )}
        </div>
      )}

    
      <div className="bcp-btn-group" style={{ marginTop: 20 }}>
        <button className="bcp-btn-back" onClick={() => navigate('/bcp')}>
          戻る
        </button>
      </div>
    </div>
  );
};

export default BcpSearch;